import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=3391c1f4&scoped=true"
import script from "./arrow.vue?vue&type=script&lang=js"
export * from "./arrow.vue?vue&type=script&lang=js"
import style0 from "./arrow.vue?vue&type=style&index=0&id=3391c1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391c1f4",
  null
  
)

export default component.exports